// 埋点
export const TaLog = function(param) {
  if (typeof window.TA != 'undefined' && param.id) {
    console.log('已埋点：', param);
    window.TA.log(param);
  } else {
    console.log('未埋点：', param);
  }
}